{
    "close": "Close",
    "copy": "Copy",
    "delete": "Delete",
    "edit": "Edit",
    "collapse": "Collapse",
    "expand": "Expand",
    "filter": "Filter",
    "history": "History",
    "more": "More",
    "refresh": "Refresh",
    "view": "View",
    "staleApp": {
        "bannerMessage": "A new version is available. Refresh after you finish your current task",
        "panelTitle": "Page updated",
        "goBack": "Go back"
    },
    "pagination": {
        "rowsPerPageLabel": "Rows per page",
        "rowsPerPage": "{{count}} per page",
        "summary": "Page {{page}} of {{totalPages}}, {{count}} total",
        "previous": "Previous",
        "next": "Next"
    }
}
